module.exports = __webpack_public_path__ + "media/images/icons/flags/CA-1c2b506356b49fe6cdf93e789c30783a.svg";